const mobileMenu = document.querySelector("[data-mobile-menu]");
const mobileMenuIcon = document.querySelector("[data-hamburger-button]");
const mobileMenuButton = document.querySelectorAll(
  ".navbar-one__menu-icon-wrapper"
);
const mobileNavMenuItems = mobileMenu?.querySelectorAll(
  ".navbar__menu .menu-item-has-children > a"
);
const mobileNavBackButtons = mobileMenu?.querySelectorAll(
  ".navbar__menu .menu-item-type-back > a"
);
const siteHeader = document.querySelector(".site-header");
const mobileMenuWrapper = document.querySelector(".navbar-one__mobile");

const subMenuInnerList = document.querySelectorAll(".sub-menu--inner");

const toggleAttribute = (element, attribute, condition) => {
  element.toggleAttribute(attribute, condition);
};

const toggleDisplay = () => {
  const menu = document.querySelector("[data-mobile-menu]");
  if (menu.hasAttribute("data-open")) {
    siteHeader.classList.add("mega-menu-open");
    siteHeader.classList.add("mobile-menu-open");
  } else {
    siteHeader.classList.remove("mega-menu-open");
    siteHeader.classList.remove("mobile-menu-open");
  }

  if (mobileMenuIcon.classList.contains("menu-open")) {
    mobileMenuIcon.classList.remove("menu-open");
  } else {
    const searchIcon = document.querySelector(".navbar-one__search-btn");
    mobileMenuIcon.classList.add("menu-open");
    document.body.classList.remove("navSearchOpen");
    searchIcon.classList.remove("close");
  }
};

const toggleMenu = (open) => {
  toggleAttribute(mobileMenu, "data-open", open);
  toggleAttribute(document.body, "tabindex", open ? "-1" : null);
  toggleDisplay();
  document.body.classList.toggle("overflow-hidden");

  if (!open) {
    mobileNavMenuItems?.forEach((itemLink) => {
      const item = itemLink.closest(".menu-item-has-children");
      const subMenu = item.querySelector(":scope > .sub-menu");
      toggleAttribute(subMenu);
    });
  }
};

const toggleMenuItem = (itemLink) => {
  const menu = itemLink.closest(".navbar__menu, .sub-menu");
  const item = itemLink.closest(".menu-item-has-children");
  const subMenu = item.querySelector(":scope > .sub-menu");
  const isOpen = subMenu.dataset.open;

  if (!isOpen) {
    menu
      .querySelectorAll(".menu-item-has-children > .sub-menu")
      .forEach((otherItemLink) => {
        const otherItem = otherItemLink.closest(".menu-item-has-children");
        const subMenu = otherItem.querySelector(".sub-menu");
        toggleAttribute(subMenu);
      });

    item.setAttribute("data-expanded", true);
    subMenu.setAttribute("data-open", true);
  } else {
    item.removeAttribute("data-expanded");
    subMenu.removeAttribute("data-open");
  }
};

mobileNavMenuItems?.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();
    toggleMenuItem(item);
  });
});

mobileMenuButton.forEach((button, index) => {
  button?.addEventListener("click", () => {
    if (index === 0) {
      // Hamburger button
      const isOpen = mobileMenu.hasAttribute("data-open");
      toggleMenu(!isOpen);
    } else {
      // Close button
      mobileNavMenuItems?.forEach((itemLink) => {
        const otherItem = itemLink.closest(".menu-item-has-children");
        otherItem.classList.remove("open");
      });
      toggleMenu(false);
    }
  });
});

mobileNavBackButtons?.forEach((button) => {
  button.addEventListener("click", () => {
    const subMenu = button.closest(".sub-menu");

    if (subMenu) {
      subMenu.removeAttribute("data-open");
    }
  });
});

// close menu on click outside menu
document.addEventListener("click", (e) => {
  if (e.target === mobileMenuWrapper) {
    const isOpen = mobileMenu.hasAttribute("data-open");
    toggleMenu(!isOpen);
  }
});

// open sub menu if only item is dropdown
const openIfOnlyItem = () => {
  subMenuInnerList.forEach((item) => {
    const menuItem = item.querySelectorAll(":scope > .menu-item");
    if (
      menuItem.length === 2 &&
      menuItem?.[1].classList.contains("menu-item-has-children")
    ) {
      const soloList = menuItem[1].querySelector(".sub-menu");
      menuItem[1].setAttribute("data-expanded", true);
      soloList.setAttribute("data-open", true);
    }
  });
};

if (document.readyState !== "loading") {
  openIfOnlyItem();
} else {
  document.addEventListener("DOMContentLoaded", openIfOnlyItem);
}
